import { FieldValues, UseFormGetValues } from "react-hook-form";
import { IGroupProps } from "../../interfaces";
import { validateEmail } from "../../utils/validatesFields";

const matchesField =
  (getValues: UseFormGetValues<FieldValues>, field: string, message: string) =>
  async (value: string) =>
    value === getValues(field) || message;

export const createFormGroups = (
  getValues: UseFormGetValues<FieldValues>
): IGroupProps[] => [
  {
    name: "",
    label: "",
    fields: [
      [
        {
          name: "email",
          label: "Email",
          type: "input",
          validate: validateEmail,
          required: true,
          noUpperCase: true,
        },
      ],
      [
        {
          name: "confirmEmail",
          label: "Confirme seu email",
          type: "input",
          required: true,
          noUpperCase: true,
          validate: matchesField(
            getValues,
            "email",
            "Os emails não conferem."
          ),
        },
      ],
      [
        {
          name: "password",
          label: "Senha",
          type: "input",
          required: true,
          isPassword: true,
          noUpperCase: true,
        },
      ],
      [
        {
          name: "confirmPassword",
          label: "Confirme sua senha",
          type: "input",
          required: true,
          isPassword: true,
          noUpperCase: true,
          validate: matchesField(
            getValues,
            "password",
            "As senhas não conferem."
          ),
        },
      ],
    ],
  },
];
